import {
  FeatureInstallStep,
  FeatureInstallStepSeparator,
} from 'components/features-page/DesktopFeaturesPage'
import { Fragment, ReactElement } from 'react'
import { Flex, Text, ThemeUIStyleObject } from 'theme-ui'
import useBreakpointIndex from 'theme/useBreakpointIndex'

interface HowToSetUpSkeletonProps {
  sxx?: ThemeUIStyleObject
  title: string
  items: SetupItem[]
}

interface SetupItem {
  title: string
  subtitle: string
  order: number
}

export default function HowToSetUpSkeleton({
  sxx,
  title,
  items,
}: HowToSetUpSkeletonProps): ReactElement {
  const breakpointIndex = useBreakpointIndex()
  const isMobile = breakpointIndex === 0

  return (
    <Flex sx={{ flexDirection: 'column', gap: ['2.4rem', '4.8rem'], alignItems: 'center', ...sxx }}>
      <Text
        variant={isMobile ? 'h2Small' : 'h2Big'}
        sx={{ textAlign: 'center', maxWidth: ['none', 'none', '60rem'] }}
        as="h2"
      >
        {title}
      </Text>
      <div
        sx={{
          display: ['flex', 'grid'],
          flexDirection: ['column', 'row'],
          gridTemplateColumns: ['1fr', '1fr auto 1fr auto 1fr'],
          alignItems: 'center',
          width: '100%',
          gap: 0,
          justifyItems: 'center',
        }}
      >
        {items.map((item, index) => (
          <Fragment key={index}>
            <FeatureInstallStep title={item.title} subtitle={item.subtitle} order={item.order} />
            {index < items.length - 1 && <FeatureInstallStepSeparator />}
          </Fragment>
        ))}
      </div>
    </Flex>
  )
}
